import { useId } from "react";
import { cn } from "./lib/utils.js";

/** The ClVaBot app mark. Decorative: every caller pairs it with the product name. */
export function BrandMark({ className }: { className?: string }) {
  const gradientId = `brand-${useId().replace(/[^a-zA-Z0-9-_]/g, "")}`;
  return (
    <svg viewBox="0 0 120 120" aria-hidden="true" className={cn("shrink-0", className)}>
      <rect width="120" height="120" rx="27" fill="#08080A" />
      <defs>
        <linearGradient
          id={gradientId}
          gradientUnits="userSpaceOnUse"
          x1="10"
          y1="0"
          x2="110"
          y2="120"
        >
          <stop offset="0" stopColor="#FFE600" />
          <stop offset="1" stopColor="#FF7A00" />
        </linearGradient>
      </defs>
      <g opacity=".28">
        <circle cx="42" cy="66" r="40" fill={`url(#${gradientId})`} />
      </g>
      <g opacity=".5">
        <circle cx="51" cy="63" r="44" fill={`url(#${gradientId})`} />
      </g>
      <circle cx="60" cy="60" r="46" fill={`url(#${gradientId})`} />
      <rect x="39" y="44" width="10" height="28" rx="5" fill="#08080A" />
      <rect x="71" y="44" width="10" height="28" rx="5" fill="#08080A" />
    </svg>
  );
}
